"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var React = require("react");
var Spinner_1 = require("../../../Animations/Spinner");
var OptionsButton_1 = require("../../../Buttons/OptionsButton");
var Icons_1 = require("../../../Icons");
var FieldViewer_1 = require("../../../Indicators/FieldViewer");
var Localization_1 = require("../../../Localization");
var Theme_1 = require("../../../Theme");
var DropListItem_1 = require("../../DropList/DropListItem");
var FieldSelector_context_1 = require("../FieldSelector.context");
var Field_styles_1 = require("./Field.styles");
var rowIcons = {
    Height: "10px",
    Width: "10px",
};
var iconSize = "16px";
var smallIconSize = "12px";
var buttonSize = "20px";
exports.Field = React.forwardRef(function (_a, ref) {
    var Item = _a.Item;
    var _b = React.useState(false), isHovering = _b[0], setIsHovering = _b[1];
    var _c = React.useState(false), isLinkingTableLoading = _c[0], setIsLinkingTableLoading = _c[1];
    var _d = React.useState(false), isLinkingFieldHovering = _d[0], setIsLinkingFieldHovering = _d[1];
    var _e = FieldSelector_context_1.useFieldSelector(), CurrentSearchString = _e.CurrentSearchString, OnInsertFunction = _e.OnInsertFunction, OnRemoveFavourite = _e.OnRemoveFavourite, OnAddFavourite = _e.OnAddFavourite, OnDeleteLinkFieldClick = _e.OnDeleteLinkFieldClick, OnLinkFieldClick = _e.OnLinkFieldClick, OnAddField = _e.OnAddField;
    React.useImperativeHandle(ref, function () { return ({
        FireAddClick: function () {
            OnAddField(Item);
        },
    }); });
    var handleInsertFunction = function () {
        OnInsertFunction(Item);
    };
    var handleRemoveFavourite = function () {
        OnRemoveFavourite(Item);
    };
    var handleAddFavourite = function () {
        OnAddFavourite(Item);
    };
    var handleLinkFieldClick = function (e) {
        e.stopPropagation();
        if (Item.IsLinkedField) {
            // run the delete field code.
            OnDeleteLinkFieldClick(Item);
        }
        else {
            // run the add field code
            setIsLinkingTableLoading(true);
            OnLinkFieldClick(Item).then(function () {
                setIsLinkingTableLoading(true);
            });
        }
    };
    var handleLinkingButtonOver = function () {
        setIsHovering(false);
        setIsLinkingFieldHovering(true);
    };
    var handleLinkingButtonOut = function () {
        setIsHovering(true);
        setIsLinkingFieldHovering(false);
    };
    var buildCaption = function () {
        var captionText = {
            Caption: Item.Caption,
            Message: "",
        };
        if (Item.IsFavourite && Item.Caption) {
            var newCaption = captionText.Caption.split(" / ");
            if (newCaption.length > 1) {
                captionText = {
                    Caption: newCaption[newCaption.length - 1],
                    Message: Item.Caption,
                };
                return captionText;
            }
        }
        return captionText;
    };
    var optionsButton = function () {
        var items = [];
        if (Item.CanAddFunction) {
            items.push(React.createElement(DropListItem_1.DropListItem, { key: "function", OnClick: handleInsertFunction }, Localization_1.strings.FieldSelector_Message_InsertFunction));
        }
        if (Item.CanFavourite) {
            if (Item.IsFavourite) {
                items.push(React.createElement(DropListItem_1.DropListItem, { key: "removefavourite", OnClick: handleRemoveFavourite }, Localization_1.strings.FieldSelector_Action_RemoveFromFavs));
            }
            else {
                items.push(React.createElement(DropListItem_1.DropListItem, { key: "addfavourite", OnClick: handleAddFavourite }, Localization_1.strings.FieldSelector_Action_AddToFavs));
            }
        }
        if (items.length > 0) {
            return (React.createElement(OptionsButton_1.OptionsButton, { Title: Localization_1.strings.Label_MoreOptions, AriaLabel: Localization_1.strings.Label_MoreOptions, IconSize: iconSize, ButtonSize: buttonSize }, items.map(function (item) { return item; })));
        }
        return null;
    };
    var displayText = buildCaption();
    return (React.createElement(Field_styles_1.FieldCaptionWrapper, { onMouseEnter: function () { return setIsHovering(true); }, onMouseLeave: function () { return setIsHovering(false); }, title: displayText.Message, "aria-label": displayText.Message, style: isHovering ? { color: Theme_1.Color.Blue.B60 } : null },
        React.createElement(Field_styles_1.IconIndicator, null,
            React.createElement(SelectedAddIndicator, { IsHovering: isHovering })),
        React.createElement(Field_styles_1.FieldCaption, null,
            React.createElement(FieldViewer_1.FieldViewer, { Highlight: CurrentSearchString, Caption: displayText.Caption, IconType: Item.IconType }),
            Item.IsLinkableField && (React.createElement(Field_styles_1.FieldLinkButton, { onMouseEnter: handleLinkingButtonOver, onMouseLeave: handleLinkingButtonOut, disabled: isLinkingTableLoading, style: buildLinkingButtonStyle(isLinkingFieldHovering, isLinkingTableLoading, Item.IsLinkedField), title: buildLinkingButtonTitle(Item.IsLinkedField), onClick: handleLinkFieldClick },
                isLinkingTableLoading && (React.createElement("div", null,
                    React.createElement(Spinner_1.Spinner, { Size: iconSize }))),
                Item.IsLinkedField && React.createElement(Icons_1.CloseThickIcon, { Height: smallIconSize, Width: smallIconSize }),
                !isLinkingTableLoading && !Item.IsLinkedField && (React.createElement(Icons_1.LinkIcon, { Height: smallIconSize, Width: smallIconSize }))))),
        React.createElement(Field_styles_1.IconIndicator, null, isHovering && optionsButton())));
});
var SelectedAddIndicator = function (_a) {
    var IsHovering = _a.IsHovering;
    if (IsHovering) {
        return React.createElement(Icons_1.PlusIcon, __assign({}, rowIcons));
    }
    return null;
};
function buildLinkingButtonTitle(IsLinkedField) {
    if (IsLinkedField) {
        return Localization_1.strings.FieldSelector_Action_DeleteLinkTableButton;
    }
    else {
        return Localization_1.strings.FieldSelector_Action_LinkTableButton;
    }
}
function buildLinkingButtonStyle(IsLinkingFieldHovering, IsLinkingTableLoading, IsLinkedField) {
    if (IsLinkingTableLoading) {
        return null;
    }
    else if (IsLinkingFieldHovering) {
        if (IsLinkedField) {
            return __assign({}, Theme_1.Color.Red.Regular);
        }
        else {
            return __assign({}, Theme_1.Color.Blue.Regular);
        }
    }
}
